
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--radio condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElRadioGroup
        ref="radioGroupRef"
        v-bind="contentProps"
        v-on="$listeners"
        :disabled="insetDisabled"
        :value="checked"
        class="condition-item__content"
        @input="change"
    >
        <template v-for="item of finalOption">
            <component
                :is="radioType"
                :key="item[valueKey]"
                :label="item[valueKey]"
                v-on:[eventName].native.prevent="customChange(item[valueKey], checked, change)"
            >
                {{ item[labelKey] }}
            </component>
        </template>
    </ElRadioGroup>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
